import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useSignUp } from '@/components/Providers/SignUpProvider'

import styles from './PricingBar.module.scss'

const PricingBar = ({ rowsGap }) => {
  const { plan, coupon } = useSignUp()

  const price = useMemo(() => (plan ? plan.amount : 0), [plan])
  const discount = useMemo(() => (coupon?.discount?.amount ? coupon.discount.amount : 0), [coupon])

  return (
    <div className={styles.priceBar} style={{ '--rows-gap': `${rowsGap}px` }}>
      <span className={styles.product}>{plan.name}:</span>
      &nbsp;
      {discount > 0 && <span className={styles.strikeThrough}>${price}</span>}
      <span className={styles.price}>
        ${price - discount}
      </span> <em className={styles.smallPrint}>(Billed {plan.isTrial ? 'yearly after free trial' : plan.frequency})</em>
    </div>
  )
}

PricingBar.propTypes = {
  rowsGap: PropTypes.number.isRequired,
}

export default PricingBar
